export type EditKeysType = 'TRACKING_NUMBER' | 'WIDTH' | 'HEIGHT' | 'LENGTH' | 'WEIGHT' | 'PALLET_SKU' | 'PCKG_SKU';

export const EDIT_KEYS = ['TRACKING_NUMBER', 'WIDTH', 'HEIGHT', 'LENGTH', 'WEIGHT', 'PCKG_SKU', 'PALLET_SKU'];
